<template>
  <div v-if="showDeleteButton" style="margin-left: 5px;">
    <span style="color: red;cursor: pointer;" @click="delOneContent(replyId)">删除</span>
  </div>
</template>

<script>
export default {
  props: {
    replyId: Number,
    userOwnTheReply: Boolean
  },
  data () {
    return {
      showDeleteButton: false
    }
  },
  mounted: async function () {
    if (this.userOwnTheReply) {
      this.showDeleteButton = true
    } else {
      this.showDeleteButton = false
    }
  },
  methods: {
    delOneContent: async function (replyId) {
      const com = confirm('确定删除此内容吗?')
      if (com) {
        const api = '/md/front/bbs/feedback/postManage/sub/del'
        let params = {
          replyId: replyId
        }
        params = this.$qs.stringify(params)
        const res = await this.axios.post(api, params)
        if (res.status === 200) {
          this.$emit('flushDateEvent')
        } else {
          alert('删除失败')
        }
      }
    }
  }
}
</script>

<style scoped></style>
